<template>
  <CRow>
    <CCol col="12" md="7">
        <CCard>
    <CCardHeader>
        <p> <img src="img/cow 4.svg" style="width:20px">  Sire</p>
        </CCardHeader>
        <CCardBody>
       <CDataTable
          :items="sireItem"
          :fields="fields"
          table-filter
          items-per-page-select
          :items-per-page="10"
          pagination
          clickable-rows
          hover
          @row-clicked="rowClicked"
          caption="Breed"
        >
        <template #status="{item}">
        <td>
          
          <CBadge :color="getBadge(item.status)">
          {{item.status}}
          
          </CBadge>
        </td>
      </template>
        </CDataTable>
        </CCardBody>
        </CCard>
    </CCol>
    <CCol col="6" md="5">
      <CCard>
          <CCardHeader>
           <p>  <img src="img/cow 4.svg" style="width:20px">  Sire Details</p>
           
          </CCardHeader>
        <CCardBody>
           <CForm>
                  
             <CInput
               
                label="Sire No"
                horizontal
                autocomplete="name"
                name="sireCode"
                id="sireCode"
                required
                v-model="sireCode"
              />
                
                  
             <CInput
               
                label="Sire Name"
                horizontal
                autocomplete="name"
                   name="sireName"
                id="sireName"
                required
                v-model="sireName"
              />
                  <CSelect
                      label="Species"
                      horizontal
                      :options="options"
                      placeholder="Please select"
                      name="species"
                      id="species"
                      :value.sync="species"
                    />
                
                  
             <CInput
               
                label="Breed"
                horizontal
                autocomplete="name"
                 name="breed"
                id="breed"
                required
                v-model="breed"
              />
                <CInput
               
                label="Purchase Source"
                horizontal
                autocomplete="name"
                 name="purchaseSource"
                id="purchaseSource"
                required
                v-model="purchaseSource"
              />
                  
 <CRow>
              <CCol sm="3">
               <h5 style="font-size:15px">Status</h5>
              </CCol>
             <CCol sm="3" >
               <input type="checkbox" id="status"   v-model="status" value="on"> 
              <!-- <CSwitch class="mx-1" color="primary" checked variant="opposite" style="width:50px;float:left !important" shape="pill"  v-bind="suspend"  name="suspend"
                id="suspend"
                 :value.sync="suspend"
                v-model="suspend"
                /> -->
                <!-- <CSwitch
              class="mx-1"
              color="primary"
              name="switch1"
              :checked.sync="suspend"
                v-model="suspend"
            /> -->
                  
              </CCol>
</CRow>
             </CForm>
            
          </CCardBody>
           <CCardFooter>
          <CButton color="info" style="width:100px" v-if="addButton" @click="addRoute">
            <CIcon name="cilPencil" />&nbsp;Add
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="saveButton" @click="updateRoute">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="danger" style="width:100px" v-if="deleteButton" @click="deleteRoute">
            <CIcon name="cilXCircle" />&nbsp;Delete
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="EditsaveButton" @click="addRoute">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="secondary" style="width:100px" v-if="cancelButton" @click="CancelRoute">
            <CIcon name="cilWarning" />&nbsp;Cancel
          </CButton>&nbsp;
          <CButton color="info" v-if="addnewButton" @click="addRouteplus">
            <CIcon name="cilPencil" />&nbsp;Add New
          </CButton>
        </CCardFooter>
        </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from '../../tables/Table'
import { APIService } from "../../../apiservice.js";
import Swal from "sweetalert2";
export default {
     components: { CTableWrapper },
 
  data () {
    return{
      status: false,
      options: ["","Cow", "Buffalo"],
      sireItem:[],
      editsire:[],
      second:[],
      sireCode:null,
      sireName:"",
      species:"",
      // breed:"",
      purchaseSource:"",
      // suspend:"",
      status:"",
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      //     suspend: {
      //   labelOn: 'yes',
      //   labelOff: 'no'
      // },
       fields: [
      {
        key: "sireCode",
        sortable: true
      },
      {
        key: "sireName",
        sortable: true
      },
    //   {
    //     key: "Contact_Number",
    //     sortable: true
    //   },
      {
        key: "species",
        sortable: true
      },
       {
        key: "breed",
        sortable: true
      },
        {
        key: "purchaseSource",
        sortable: true
      },
      //  {
      //   key: "status",
      //   sortable: true
      // },
      { key: 'status', _style:'width:20%;' },
      
    ],
    items: [
      
        
    
   
    ]
    }
  },
  methods: {
      getBadge (status) {
      switch (status) {
        case 'true': return 'success'
        case 'Inactive': return 'secondary'
        case 'false': return 'warning'
        case 'Banned': return 'danger'
        default: 'primary'
      }
    },
    getSireList() {
      APIService.sireList().then(res => {
        if (res.status == 200) {
          this.sireItem = res.data;
             
      this.sireCode = this.sireItem[0].sireCode;
      this.sireName = this.sireItem[0].sireName;
      this.species = this.sireItem[0].species;
      this.breed = this.sireItem[0].breed;
      this.purchaseSource = this.sireItem[0].purchaseSource;
      this.status = this.sireItem[0].status;



          let value = this.sireItem.map(n => {
            return n.status;
          });
          //  this.second = value;
          //  console.log("data", this.second)
          
          // for(let i = 0; i <this.second.length;i++)
          // {
          //      if(this.second  == true)
          //   {
          //    Item.status ="one"
          //   }else
          // {
          //      Item.status ="two"
          // }

          // }
        }
      });
    },

    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.editsire = item;
      this.sireCode = item.sireCode;
      this.sireName = item.sireName;
      this.species = item.species;
      this.breed = item.breed;
      this.purchaseSource = item.purchaseSource;
      this.status = item.status;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
    },
    addRoute() {
      let sireCode = this.sireCode;
      let sireName = this.sireName;
      let species = this.species;
      let breed = this.breed;
      let purchaseSource = this.purchaseSource;
      let status = this.status;
      let data = {
        sireCode,
        sireName,
        species,
        breed,
        purchaseSource,
        status
      };
      APIService.saveSire(data).then(res => {
        if (res.status == 200) {
          this.sireCode = null;
          this.sireName = "";
          this.species = "";
          this.breed = "";
          this.purchaseSource = "";
          this.status = "";
          this.getSireList();
            Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    addRouteplus() {
        this.sireCode = null;
          this.sireName = "";
          this.species = "";
          this.breed = "";
          this.purchaseSource = "";
          this.status = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      this.EditsaveButton = true;  
      return getSireList();
    },

    CancelRoute() {
        this.sireCode = null;
          this.sireName = "";
          this.species = "";
          this.breed = "";
          this.purchaseSource = "";
          this.status = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false,  
      this.getSireList();
    },
    updateRoute() {
       let id = this.editsire._id;
      let sireCode = this.sireCode;
      let sireName = this.sireName;
      let species = this.species;
      let breed = this.breed;
      let purchaseSource = this.purchaseSource;
      let status = this.status;
      let value = {
        sireCode,
        sireName,
        species,
        breed,
        purchaseSource,
        status
      };
      let data = { id, value };
      APIService.sireUpdate(data).then(res => {
        if (res.status == 200) {
        this.sireCode = null;
          this.sireName = "";
          this.species = "";
          this.breed = "";
          this.purchaseSource = "";
          this.status = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
         this.getSireList();
           Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    deleteRoute() {
      const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: false
})

swalWithBootstrapButtons.fire({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
  cancelButtonText: 'No, cancel!',
  reverseButtons: true
}).then((result) => {
  if (result.value) {
    swalWithBootstrapButtons.fire(
      'Deleted!',
      'Your file has been deleted.',
      'success'
    )
     this.delete();
  } else if (
    /* Read more about handling dismissals below */
    result.dismiss === Swal.DismissReason.cancel
  ) {
    swalWithBootstrapButtons.fire(
      'Cancelled',
      'Your imaginary file is safe :)',
      'error'
    )
  }
})

    },
    delete(){
      let id = this.editsire._id;
      let data = { id };
      APIService.sireDelete(data).then(res => {
        if (res.status == 200) {
            this.sireCode = null;
          this.sireName = "";
          this.species = "";
          this.breed = "";
          this.purchaseSource = "";
          this.status = "";
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          (this.EditsaveButton = false),  this.getSireList();
        }
      });
    }
  },
  created() {
    this.getSireList();
  }
}
</script>
